module.exports = __webpack_public_path__ + "static/poster_mod_current-6da922ac5244ab2dcc0e37ca17233433.jpg";